import { MessageIncomingEvent } from '@wui/im'

import { useCurrentUser } from '@/shared/composables/current-user'
import { NoCurrentUserError } from '@/shared/errors'

import { useChatMessageStore } from '../model/chat'

export const isCurrentUserMentionedOrQuotedAtMessage = (message: MessageIncomingEvent) => {
  const { currentUser } = useCurrentUser()
  const currentUserImLogin = currentUser.value?.imLogin
  if (!currentUserImLogin) {
    throw new NoCurrentUserError()
  }

  if (!!message.mentionedUsers?.find((s) => s === currentUserImLogin)) {
    return true
  }
  if (message.quote?.quotedEventId) {
    const quotedMessage = useChatMessageStore().findById(message.quote.quotedEventId)  // todo if not in history
    return quotedMessage?.item.type === 'OutgoingMessageEvent'
  }
  return false
}
